import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Utils } from '../../utils';

declare var anychart: any
// import 'anychart';

@Component({
  selector: 'app-polar-chart',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './polar-chart.component.html',
  styleUrl: './polar-chart.component.scss'
})
export class PolarChartComponent implements OnInit, AfterViewInit, OnDestroy {
  loaderScripts = false;
  loading = false;
  async ngOnInit(): Promise<void> {
    const me = this;
    this.loading = true;


    await Utils.loadScript("file1", "https://cdn.anychart.com/releases/8.13.0/js/anychart-core.min.js")
      .then(async data => {
        await Utils.loadScript("file2", "https://cdn.anychart.com/releases/8.13.0/js/anychart-polar.min.js")
          .then(data => {
            me.loaderScripts = true;
            me.apply();
          })
          .catch(err => {
            console.error(err);
          });
      })
      .catch(err => {
        console.error(err);
      });
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
      this.loaderScripts = false;
      this.chartElement.nativeElement.innerHTML = '';

      let file1 = document.getElementById("file1");
      let file2 = document.getElementById("file2");
      anychart = null;

      if (file1) document.body.removeChild(file1);

      if (file2) document.body.removeChild(file2);

    }
  }
  @ViewChild('chart') chartElement!: ElementRef;
  chart: any;

  ngAfterViewInit(): void {

  }
  private _data: any[] = [];

  @Input()
  set data(data: any[]) {
    this._data = data;
    if (this.chartElement && this.loaderScripts) {
      this.apply();
    }

  }
  get data(): any[] {
    return this._data;
  }

  @Output() onLoaded: EventEmitter<number> = new EventEmitter<number>();


  private apply() {
    if (this.chart) {
      this.chart.removeAllSeries();
      const column = this.chart.column(this.data);
      column.stroke({ thickness: 0 });
    }
    else {
      this.chart = anychart.polar();
      let column = this.chart.column(this._data);
      column.stroke({ thickness: 0 });

      this.chart.innerRadius('10%')
        .yAxis(true)
        .xScale('ordinal');
      var scale = this.chart.yScale();
      scale.maximum(10);
      scale.minimum(0);
      scale.ticks().interval(1);
      this.chartElement.nativeElement.innerHTML = '';
      this.chart.container(this.chartElement.nativeElement);
      this.chart.draw(true);

    }
    this.loading = false;

  }




}
